<template>
  <div class="info-container">
    <leftDetail
      v-if="showDetail"
      @closeDialog1="closeDialog1"
      ref="showDetail"
    />
    <div class="info-row">
      <div class="info-label">农服商名称：</div>
      <div class="info-value">{{ info.companyName }}</div>
    </div>
    <div class="info-row">
      <div class="info-label">经营场所地址：</div>
      <div class="info-value">{{ info.companyAddress }}</div>
    </div>
    <div class="info-row">
      <div class="info-label">联系人：</div>
      <div class="info-value">{{ info.contactName }}</div>
    </div>
    <div class="info-row">
      <div class="info-label">联系电话：</div>
      <div class="info-value">{{ info.contactPhone }}</div>
    </div>
    <div class="info-row score-container">
      <div class="info-label">综合评分：</div>
      <div v-if="info.average" class="star-rating">
        <span
          v-for="index in 5"
          :key="index"
          :class="['star', { active: index <= starCount }]"
          >★</span
        >
      </div>
      <div  class="info-value" v-else>暂无评分</div>
      <!-- {{ info.average ? `(${info.average})` : "(暂无评分)" }} -->
    </div>
    <!-- <div>供应信息：
        <ul>
          <li v-for="item in info.companyVo" :key="item.code">
            <div class="new-date">
              <span>{{item.dayNum}}</span>
              <p>{{item.yearNum}}.{{item.monthNum}}</p>
            </div>
            <div class="new-title" @click="detailClick(item)">
              {{item.intentionRegion}}{{item.serviceType == 1 ? "全程托管" : "环节托管"}} {{item.serviceArea ? item.serviceArea : 0}}"亩"
                {{item.serviceScope}}
            </div>
          </li>
        </ul>
    </div> -->
  </div>
</template>

<script>
import leftDetail from "../../homepage/components/SupplyTgLeftDetail.vue";
import { mapGetters } from "vuex";
import { SendMessage, companyByid } from "@/api/websocket.js";
export default {
  props: ["info"],
  computed: {
    ...mapGetters(["topSelectAreacode", "topSelectAreaname", "identityObj"]),
    starCount() {
      return Math.round(this.info.average) || 0;
    },
  },
  components: {
    leftDetail,
  },
  data() {
    return {
      showDetail: false,
    };
  },
  methods: {
    closeDialog1() {
      this.showDetail = false;
    },

    /**
     * 在线沟通
     */
    // async handleClick(info) {
    //   if (info.authId == this.identityObj.identityId) {
    //     this.$message.info("本人项目");
    //   } else {
    //     let content2 = JSON.stringify(info);
    //     console.log("wxf", content2);
    //     let params = {
    //       messageList: [
    //         {
    //           //消息类型会话托管
    //           messageType: 5,
    //         },
    //       ],
    //       receiverId: info.authId,
    //       senderType: this.identityObj.identityTypeCode,
    //       //接受消息人类型只有公司认证用户
    //       receiverType: 4,
    //       senderId: this.identityObj.identityId,
    //       sender: this.identityObj.realName,
    //       receiver: info.companyName,
    //     };
    //     let res = await SendMessage(params);
    //     if (res.code == 0) {
    //       console.log(this.$router,"发送成功");
    //       this.$router.push({
    //         path: "/home/Chat",
    //         query: {
    //           isshow: true, // 你要传递的参数
    //           // data: info,
    //           num: 1,
    //         },
    //       });
    //     }
    //   }

    // },

    detailClick(val) {
      this.showDetail = true;
      this.$nextTick(() => {
        this.$refs.showDetail.init(val);
        console.log("val", val);
      });
      console.log(val, "进行");
    },
  },
};
</script>
<style lang="less" scoped>
@import "~@/styles/JStyle";
.custom-button {
  margin-left: 10px;
  color: #3418c4;
}
li {
  border-bottom: dashed 1px rgba(112, 112, 112, 0.3);
  display: flex;
  padding: 10px 0;

  &:last-child {
    border-bottom: 0;
  }
  .new-date {
    background: #9caba9;
    text-align: center;
    color: #fff;
    width: 56px;
    height: 52px;
    padding: 0 5px;
    margin-right: 15px;
    font-family: "Arial";
    span {
      font-size: 30px;
    }
    p {
      font-size: 12px;
      margin: 0;
      padding: 0;
    }
  }

  .new-title {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    cursor: pointer;
    flex: 1;
    > span {
      margin-top: 5px;
      font-size: 16px;
      color: #666;
      font-weight: bold;
    }
    .addressAndName {
      display: flex;
      justify-content: space-between;

      .address {
        margin-right: 24px;
      }
    }

    p {
      color: rgba(102, 102, 102, 0.6);
      margin-top: 5px;
      margin-bottom: 0;
      padding: 0;
      width: 100%;
      display: flex;

      > span {
        flex: 1;
        text-align: right;
      }
    }
  }
}

.score-container {
  display: flex;
  align-items: center;
  margin: 8px 0;

  .star-rating {
    margin-left: 8px;
    .star {
      color: #cccccc;
      font-size: 16px;
      margin-right: 2px;
      &.active {
        color: #ffa500;
      }
    }
  }
}
</style>
